module.exports = __webpack_public_path__ + "img/tick-double.8f48cf62.svg";